export const manageBgValue = (type, value, id) => ({
    type,
    value,
    id
});

const initialState = {value: '', id: ''};

export default (state = initialState, action = {}) => {
    if (action.value !== undefined) {
        return Object.assign({}, {value: action.value, id: action.id});
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/state/cellValue.js